'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const RefundIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M20.2001 20H3.80005C2.90005 20 2.30005 19.4 2.30005 18.5V7.6C2.30005 6.7 2.90005 6.1 3.80005 6.1H5.00005V7.1H3.80005C3.50005 7.1 3.30005 7.3 3.30005 7.6V9.5H5.00005V10.5H3.30005V18.5C3.30005 18.8 3.50005 19 3.80005 19H20.2001C20.5 19 20.7001 18.8 20.7001 18.5V10.5H11V9.5H20.7001V7.6C20.7001 7.3 20.5 7.1 20.2001 7.1H11V6.1H20.2001C21.1 6.1 21.7001 6.7 21.7001 7.6V18.5C21.7001 19.4 21.1 20 20.2001 20ZM8.00005 15.9L5.40005 13.3L6.10005 12.6L7.50005 14V4.8C7.50005 3.4 8.60005 2.3 10 2.3H11V3.3H10C9.20005 3.3 8.50005 4 8.50005 4.8V14L9.80005 12.7L10.5 13.4L8.00005 15.9Z",
        fill: "currentColor"
      }
    )
  }
);
const VpRefundIcon = forwardRef(RefundIcon);

export { VpRefundIcon as default };
